<template>
  <b-navbar type="dark" variant="primary">
    <div class="container">
      <b-navbar-brand href="#">  <img src="../../public/logo/white.png" alt="logo" /></b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-b-toggle.sidebar-1
          ><span class="navbar-toggler-icon"></span
        ></b-nav-item>
        <b-sidebar
          id="sidebar-1"
          :title="GetLoggedInUser"
          bg-variant="primary"
          text-variant="white"
          right
          shadow
        >
          <nav class="mb-3">
            <b-nav vertical>
              <div v-if="IsLoggedIn" >
                 <b-nav-item href="/"><h5  class="text-white">Home</h5 ></b-nav-item>
                 <b-nav-item href="/country"><h5  class="text-white">Shop</h5 ></b-nav-item>
                 <b-nav-item href="/users"><h5  class="text-white">Users</h5 ></b-nav-item>
                 <b-nav-item href="/walletTransactions"><h5  class="text-white">Wallet</h5 ></b-nav-item>
                 <b-nav-item href="/replay"><h5  class="text-white">Refresh Zesa</h5 ></b-nav-item>
                 <b-nav-item href="/productDetail"><h5  class="text-white">Discounts</h5 ></b-nav-item>
                 <b-nav-item href="/generalsettings"><h5  class="text-white">General Settings</h5 ></b-nav-item>
                 <b-nav-item v-b-toggle.reports-collapse><h5 class="text-white">Reports ▾</h5></b-nav-item>
                 <b-collapse id="reports-collapse" class="ml-3">
                   <b-nav-item href="/metrics"><h6 class="text-white">Metrics</h6></b-nav-item>
                   <b-nav-item href="/walletreport"><h6 class="text-white">Wallet Report</h6></b-nav-item>
                   <b-nav-item href="/walletcommissionreport"><h6 class="text-white">Commission Report</h6></b-nav-item>
                   <b-nav-item href="/referralCommissionReport"><h6 class="text-white">Referral Commission Report</h6></b-nav-item>
                   <b-nav-item href="/customeroveraltransactions"><h6 class="text-white">Customer Transactions</h6></b-nav-item>
                   <b-nav-item href="/customertransactions"><h6 class="text-white">Transaction Status</h6></b-nav-item>
                   <b-nav-item href="/stockorders"><h6 class="text-white">Stock Orders</h6></b-nav-item>
                   <b-nav-item href="/stockorderaccess"><h6 class="text-white">Stock Order Access</h6></b-nav-item>
                   <b-nav-item href="/relayedsms"><h6 class="text-white">Relayed SMS</h6></b-nav-item>
                   <b-nav-item href="/relayeddeposits"><h6 class="text-white">Relayed Deposits</h6></b-nav-item>
                   <b-nav-item href="/productreport"><h6 class="text-white">Product Report</h6></b-nav-item>
                   <b-nav-item href="/agentmonthlysales"><h6 class="text-white">Agent Monthly Sales</h6></b-nav-item>
                   <b-nav-item href="/agentgrowthreport"><h6 class="text-white">Agent Growth Report</h6></b-nav-item>
                   <b-nav-item href="/usersreport"><h6 class="text-white">User Signon Report</h6></b-nav-item>
                 </b-collapse>
                 <b-nav-item @click="SignOut" href="#"><h5  class="text-white">Log Out</h5 ></b-nav-item>
              </div>
              <div v-else>
                <b-nav-item href="/login"><h5  class="text-white">Sign In</h5 ></b-nav-item>
                <b-nav-item v-bind:href="register"><h5  class="text-white">Sign Up</h5 ></b-nav-item>
              </div>

            </b-nav>
          </nav>
        </b-sidebar>
      </b-navbar-nav>
    </div>
  </b-navbar>

</template>
<script>
import { userAuth } from "../services/security";
import config from "@/settings/config.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  components: {
    Loading,
  },
  data: function () {
    return {
      register: "/register",
      isLoading: true,
      fullPage: true,
      Message: "Welcome to umbai",
    };
  },
  computed: {
    IsLoggedIn: function () {
      if (userAuth.data().user.isAuthenticated) {
         return true
      }
      return false;
    },
    GetLoggedInUser: function () {
      return userAuth.GetUserName();
    },
  },
  methods: {
    SignIn: async function () {
      await userAuth.signIn("/users");
    },
    SignOut: async function () {
      await userAuth.SignOut();
    },
  },
};
</script>
<style>
</style>